import { render, staticRenderFns } from "./RecentCallsList.vue?vue&type=template&id=44fc07c6&"
import script from "./RecentCallsList.vue?vue&type=script&lang=js&"
export * from "./RecentCallsList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports